import { render, staticRenderFns } from "./Advisees.vue?vue&type=template&id=539d3ef9"
import script from "./Advisees.vue?vue&type=script&lang=js"
export * from "./Advisees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports